import { moveElementError } from "@planzone/dto";
import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({
    projectElementId,
    projectElementType,
    currentParentList,
    nextParentList,
    range,
    alignDates,
  }) => {
    return present(
      repository
        .moveProjectElement(
          projectElementId,
          projectElementType,
          nextParentList,
          range,
          alignDates,
        )
        .then(() => ({
          projectElementId,
          projectElementType,
          currentParentList,
          nextParentList,
          range,
          alignDates,
        }))
        .catch((e) =>
          Promise.reject({
            projectElementId,
            projectElementType,
            currentParentList,
            nextParentList,
            range,
            alignDates,
            error: { ...moveElementError, ...e },
          }),
        ),
    );
  };
}

export type { Interactor };

export { createInteractor };
